export default __webpack_public_path__ + "static/media/croptop-small-front-toobig.cc588430.jpg";